export enum DayOfWeek {
  Monday = "Monday",
  Tuesday = "Tuesday",
  Wednesday = "Wednesday",
  Thursday = "Thursday",
  Friday = "Friday",
  Saturday = "Saturday",
  Sunday = "Sunday",
}

export enum HourOfDay {
  HOUR_00_00 = "00:00",
  HOUR_00_30 = "00:30",
  HOUR_01_00 = "01:00",
  HOUR_01_30 = "01:30",
  HOUR_02_00 = "02:00",
  HOUR_02_30 = "02:30",
  HOUR_03_00 = "03:00",
  HOUR_03_30 = "03:30",
  HOUR_04_00 = "04:00",
  HOUR_04_30 = "04:30",
  HOUR_05_00 = "05:00",
  HOUR_05_30 = "05:30",
  HOUR_06_00 = "06:00",
  HOUR_06_30 = "06:30",
  HOUR_07_00 = "07:00",
  HOUR_07_30 = "07:30",
  HOUR_08_00 = "08:00",
  HOUR_08_30 = "08:30",
  HOUR_09_00 = "09:00",
  HOUR_09_30 = "09:30",
  HOUR_10_00 = "10:00",
  HOUR_10_30 = "10:30",
  HOUR_11_00 = "11:00",
  HOUR_11_30 = "11:30",
  HOUR_12_00 = "12:00",
  HOUR_12_30 = "12:30",
  HOUR_13_00 = "13:00",
  HOUR_13_30 = "13:30",
  HOUR_14_00 = "14:00",
  HOUR_14_30 = "14:30",
  HOUR_15_00 = "15:00",
  HOUR_15_30 = "15:30",
  HOUR_16_00 = "16:00",
  HOUR_16_30 = "16:30",
  HOUR_17_00 = "17:00",
  HOUR_17_30 = "17:30",
  HOUR_18_00 = "18:00",
  HOUR_18_30 = "18:30",
  HOUR_19_00 = "19:00",
  HOUR_19_30 = "19:30",
  HOUR_20_00 = "20:00",
  HOUR_20_30 = "20:30",
  HOUR_21_00 = "21:00",
  HOUR_21_30 = "21:30",
  HOUR_22_00 = "22:00",
  HOUR_22_30 = "22:30",
  HOUR_23_00 = "23:00",
  HOUR_23_30 = "23:30",
}

// export interface DateAndHourOfDay {
//   date: Date;
//   hourOfDay: HourOfDay;
// }

export function DateToHourOfDay(date: Date): HourOfDay {
  const utcHours = date.getUTCHours();
  const utcMinutes = date.getUTCMinutes();
  const roundedToNearestHalfHour = Math.round(utcMinutes / 30) * 30;
  if (roundedToNearestHalfHour === 60) {
    if (utcHours === 23) {
      return HourOfDay.HOUR_00_00;
    }
    return `${(utcHours + 1).toString().padStart(2, "0")}:00` as HourOfDay;
  }
  return `${utcHours.toString().padStart(2, "0")}:${roundedToNearestHalfHour.toString().padStart(2, "0")}` as HourOfDay;
}
